import React from 'react';

import {ImageBlock} from '../image/ImageBlock';
import type {ImageWeb} from '../image/types';

type PropType = {
	selected: boolean;
	index: number;
	onClick: () => void;
	image: ImageWeb;
	total: number;
};

export const Thumb: React.FC<PropType> = (props) => {
	const {selected, index, onClick, image, total} = props;

	return (
		<div
			className={'embla-thumbs__slide'.concat(
				selected ? ' embla-thumbs__slide--selected' : '',
			)}
		>
			<button onClick={onClick} type="button" className="embla-thumbs__slide__number">
				<ImageBlock
					src={image.image.src}
					alt=""
					height={image.image.height}
					width={image.image.width}
				/>
				<span className="sr-only">
					Bilde {index + 1} av {total}
				</span>
			</button>
		</div>
	);
};
